export const AgenticChatbotConstants = {
  INITIAL_QUERY: "first_time_greeting",

  SOMETHING_WENT_WRONG: "Something went wrong. Please try again.",
  CONTRACT_DRAFTING: "CONTRACT_DRAFTING",
  CREATE_DRAFT: "Draft contract only",
  ASK_ASTRO: "Ask Orion",
  DRAFT_CONTRACT: "Draft Contract",
  REVIEW_CONTRACT: "Review Contract",
  GENERATING_CONTRACT_DRAFT: " Generating Contract Draft",
  UPLOAD_INTAKE_FORM: "Upload Intake Form",
  REVIEW: "Review Contract",
  RECENT_CONTRACTS: "Recent Contracts",
  SEARCH: "Search",
  UPLOAD_CONTRACT: "Upload Contract",
  REVIEWING_CONTRACT_STEPS: [
    "Uploaded And Analyzing...",
    "Detecting Important Sections...",
    "Checking Compliance Issues...",
    "Assessing Risks And Obligations...",
    "Summarizing Findings...",
    "Generating Comments And Suggestions...",
  ],
  REVIEW_RECENT_CONTRACTS: "Fetch recent contract",
  SEARCH_CONTRACT: "Search Contract",
  MAIN_MENU: "Main Menu",
  CHAT_HISTORY: "Chat History",
};
